import { ArrowLeft, CheckCircle, Video } from "lucide-react";
import { useNavigate } from "react-router-dom";

function StreamingEnd() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[calc(100vh-70px)] bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Icon Container */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-green-400 rounded-full opacity-20 animate-ping"></div>
              <div className="relative bg-green-100 p-4 rounded-full">
                <CheckCircle className="w-12 h-12 text-green-600" />
              </div>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
            Streaming Has Been Completed
          </h1>

          {/* Description */}
          <p className="text-slate-600 mb-6 leading-relaxed">
            The live streaming session has successfully concluded. Thank you for
            joining us. The recorded video will be available soon (if
            applicable).
          </p>

          {/* Status Indicators */}
          <div className="bg-slate-50 rounded-xl p-4 mb-6 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <Video className="w-4 h-4 text-slate-500" />
                <span className="text-slate-700">Stream Status</span>
              </div>
              <span className="text-green-600 font-medium">Completed</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-slate-400 rounded"></div>
                <span className="text-slate-700">Live Session</span>
              </div>
              <span className="text-slate-500 font-medium">Ended</span>
            </div>
          </div>

          {/* Action Button */}
          <button
            onClick={() => navigate(-1)}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </button>

          {/* Help Text */}
          <p className="text-xs text-slate-500">
            If you missed the session, please check back later for a recording
            or contact the organizer for more details.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StreamingEnd;
